module.exports = __webpack_public_path__ + "img/sao-tome-and-principe.232b0c8a.png";